import React from "react";
import { Card, Typography, Box, Avatar, Chip, Divider } from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import InteractiveAction2 from "../../../widgets/InteractiveAction2";

const UserDetailCard = ({ user }) => {
  const {
    companyName,
    contactSalutation,
    contactFirstName,
    contactLastName,
    contactDesignation,
    companyEmail,
    contactEmail,
  } = user;

  return (
    <Card
      elevation={0}
      sx={{
        maxWidth: 360,
        margin: "auto",
        border: "none",
        backgroundColor: "transparent",
        overflow: "visible",
        mt: 4,
      }}
    >
      <Box
        sx={{
          position: "relative",
          pt: 6,
          px: 2,
          pb: 2,
          backgroundColor: "#fff",
          borderRadius: 4,
          zIndex: 1,
          boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
        }}
      >
        <Box
          display="flex"
          justifyContent="center"
          sx={{ position: "absolute", top: -36, left: 0, right: 0 }}
        >
          <Avatar
            alt={companyName.value}
            sx={{
              width: 72,
              height: 72,
              bgcolor: "#0ea5e9",
              color: "#fff",
              fontSize: 28,
              border: "4px solid #fff",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            }}
          >
            {companyName.value.charAt(0)}
          </Avatar>
        </Box>

        <Box textAlign="center" mb={1}>
          <Typography
            variant="h6"
            fontWeight={800}
            color="#1e293b"
            sx={{ lineHeight: 1.2 }}
          >
            {companyName.value}
          </Typography>
        </Box>

        <Box textAlign="center" mb={3}>
          <Typography variant="body1" fontWeight={600} color="#334155">
            {`${contactSalutation.value} ${contactFirstName.value} ${contactLastName.value}`}
          </Typography>
          <Typography variant="body2" color="#64748b" fontWeight={500}>
            {contactDesignation.value}
          </Typography>
        </Box>

        <Box display={"flex"} justifyContent={"center"} mb={3}>
          <InteractiveAction2 item={user} />
        </Box>

        <Divider sx={{ mb: 2, borderColor: "#f1f5f9" }} />

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 3 }}>
          <Box>
            <Typography
              variant="caption"
              fontWeight={700}
              color="#94a3b8"
              textTransform="uppercase"
              letterSpacing={0.5}
            >
              Contact Information
            </Typography>
            <Box mt={1}>
              <Box display="flex" alignItems="center" gap={1}>
                <EmailOutlinedIcon sx={{ fontSize: 16, color: "#94a3b8" }} />
                <Typography variant="body2" color="#334155" fontWeight={500}>
                  {companyEmail.value}
                </Typography>
              </Box>
              <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                <PersonOutlineOutlinedIcon
                  sx={{ fontSize: 16, color: "#94a3b8" }}
                />
                <Typography variant="body2" color="#334155" fontWeight={500}>
                  {contactEmail.value}
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box>
            <Typography
              variant="caption"
              fontWeight={700}
              color="#94a3b8"
              textTransform="uppercase"
              letterSpacing={0.5}
            >
              Address
            </Typography>
            <Box display="flex" gap={1} mt={0.5}>
              <LocationOnOutlinedIcon
                sx={{ fontSize: 16, color: "#94a3b8", mt: 0.25 }}
              />
              <Typography
                variant="body2"
                color="#475569"
                sx={{ whiteSpace: "pre-line", lineHeight: 1.5 }}
              >
                {[
                  [
                    user.address1?.value,
                    user.address2?.value,
                    user.address3?.value,
                  ]
                    .filter(Boolean)
                    .join(", "),
                  user.city?.value?.name,
                  user.state?.value?.name,
                  user.country?.value?.name,
                  user.pin?.value && `PIN: ${user.pin.value}`,
                ]
                  .filter(Boolean)
                  .join("\n")}
              </Typography>
            </Box>
          </Box>
        </Box>

        {user.productCategories?.value?.length > 0 && (
          <Box>
            <Typography
              variant="caption"
              fontWeight={700}
              color="#94a3b8"
              textTransform="uppercase"
              letterSpacing={0.5}
              sx={{ display: "block", mb: 1.5 }}
            >
              Product Categories
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {user.productCategories.value.map((category, index) => {
                const subSubCatName =
                  category.subSubCat.split(" - ")[1] || category.subSubCat;
                return (
                  <Chip
                    key={index}
                    label={subSubCatName}
                    size="small"
                    icon={
                      <CategoryOutlinedIcon
                        sx={{ fontSize: "14px !important" }}
                      />
                    }
                    sx={{
                      backgroundColor: "#f1f5f9",
                      color: "#334155",
                      fontWeight: 500,
                      borderRadius: "6px",
                      "& .MuiChip-label": { px: 1.5, pl: 0.5 },
                    }}
                  />
                );
              })}
            </Box>
          </Box>
        )}
      </Box>
    </Card>
  );
};

export default UserDetailCard;
